import React from 'react';
import Popup from './Popup';
import SearchTable from './SearchTable';
import db from './db';
export default class TableAddEdit extends React.Component {

    // constructor
    constructor(props) {
        super(props);
        this.searchTableRef = React.createRef();
        this.addButtonRef = React.createRef();
        // initalize state
        this.state = {
            tableList:[],
            postObj:[],
            selectedObject:false
          }
    }
    queryData(callback) {
        this.searchTableRef.current.queryData(callback);
    }
    // render
    render() {
        let body="";
        let buttonClassName="";
        if(this.props.children){
            body=this.props.children;
            buttonClassName="hidden"
        } else if(this.props.showEditScreen){
            buttonClassName="hidden"
        } else {
            body=getEditScreen( 
                    this.props.columns
                    ,this.state.selectedObject
                    ,this.changeFieldValue.bind(this));
        }
        return (
            <div key='TableAddEditDiv1'>
                <button onClick={this.addObject.bind(this)}
                    ref={this.addButtonRef}
                >Add</button>               
                <SearchTable 
                    columns={this.props.columns} 
                    securityObject={this.props.securityObject}
                    query={this.props.securityObject.httpServer+this.props.queryURL}
                    dataSource={this.state.tableList}
                    tableHeight={this.props.tableHeight}
                    onClick={this.editObject.bind(this)}
                    ref={this.searchTableRef}
                    afterQuery={this.props.afterQuery}
                    />
                <Popup
                    trigger={this.state.selectedObject}
                > 
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div> 
                    <button className={buttonClassName} disabled={this.areButonsDisabled()} onClick={() => this.saveChanges()}>Save</button>
                    <button className={buttonClassName} disabled={this.areButonsDisabled()} onClick={() => this.closePopup()}>Cancel</button>                    
                    {body}
                   
                </Popup>       
            </div>
        );
    }

    // close the popup
    closePopup(){
        this.setState({
            selectedObject:false
        });
    }

    // open the popup
    editObject( rowData, rowIndex ){  
        if (this.props.showEditScreen){
            this.props.showEditScreen(rowData, rowIndex);
        } else {
            let postObj={id:rowData.id}; 
            this.setState({
                selectedObject:rowData,
                postObj:postObj
            });    
        }
    }
    addObject(){
        let rowData={id:-1};
        this.editObject(rowData);
    }
    changeFieldValue(event) {
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        let postObj=this.state.postObj
        postObj[key]=val;
        this.setState({postObj:postObj})
    }
    saveChanges(){
        let thisInFunction=this;
        db.saveData( this.props.securityObject
            , this.state.postObj
            ,this.props.updateURL
            , function(res){
                if(res.resultCode===1){
                    thisInFunction.closePopup();
                } else {
                    //window.alert(JSON.stringify(res));
                }
            });        
    }
    areButonsDisabled(){
        //return false;    
        if(this.state.postObj){
            return Object.keys(this.state.postObj).map.length<=1;
        } else {
            return false;
        }
    }
    getSelectedObject(){
        return this.state.selectedObject;
    }
    
}

export function getEditScreen( columns, selectedObject, changeFieldValue){
    let result=[];
    let keyno=1000;
    columns.forEach(col => {
        //keyno++;
        let editClassName="table-add-edit-title-span";
        if(col.editClassName){
            editClassName=col.editClassName;
        }
        result.push(
            React.createElement('span',
                {className:editClassName, key:keyno++, id:`labelTableAddEdit${col.key}`}
                ," "+col.title+": "));
        editClassName="table-add-edit-title-input";
        if(col.editClassName){
            editClassName=col.editClassName;
        }
        if(col.noedit){
            //keyno++;
            result.push(React.createElement(
                'span', 
                { key:keyno++
                    , defaultValue:selectedObject[col.key]
                    ,id:`spanTableAddEdit${col.key}`
                    ,className:editClassName
                },
                selectedObject[col.key]
            ));
        } else if(col.options) {
            let opts=[];
            col.options.forEach( opt=> {
                //let selected=(opt.value==selectedObject[col.key]);
                //keyno++
                opts.push( React.createElement(
                                'option'
                                ,{
                                    value:opt.value
                                    //, selected:selected
                                    ,key:keyno++
                                }
                                ,opt.label));
            })
            
            //keyno++;
            result.push(React.createElement(
                'select', 
                {
                    defaultValue:selectedObject[col.key],
                    onChange:changeFieldValue,
                    name:col.key,
                    id:`inputTableAddEdit${col.key}`,
                    className:editClassName,
                    key:keyno++
                }, 
                opts                  
                ));
        } else if(col.memo) {
            //keyno++;
            result.push(React.createElement(
                'textarea', 
                {
                    defaultValue:selectedObject[col.key],
                    onChange:changeFieldValue,
                    name:col.key,
                    id:`inputTableAddEdit${col.key}`,
                    className:editClassName,
                    key: keyno++
                }
            ));
        } else {
            //keyno++;
            result.push(React.createElement(
                'input', 
                {
                    defaultValue:selectedObject[col.key],
                    onChange:changeFieldValue,
                    name:col.key,
                    id:`inputTableAddEdit${col.key}`,
                    className:editClassName,
                    key: keyno++
                }
            ));
        }
        
        result.push(React.createElement('br', {key:keyno++},undefined));
    });
    return result;
}
